module.exports = __webpack_public_path__ + "static/media/294592.9e81a4a1.png";